import { observer } from 'mobx-react';
import { Button, Spinner } from '@teliaee/design-system';
import qs from 'qs';
import React from 'react';
import { UI_WEB_API_PATH } from '../Routes';
import useStores from '../stores/UseStores';
import { API } from '../util/ApiUtil';
import { propagateWebApiState } from '../util/WebApiUtil';

export type WebApiResponse = {
  action: string;
  auth: any;
  token: string;
  am: string;
  error: string;
  essionExpirationTime: number;
  isAppAgent: boolean;
  isDeeplink: boolean;
  deeplink: string;
  deeplinkText: string;
  deeplinkDescription: string;
} | null;

const WebApi = observer((): React.JSX.Element | null => {
  const [deeplink, setDeeplink] = React.useState<WebApiResponse>(null);
  const { client, routeStore, translateStore } = useStores();
  const paramString = routeStore.params;
  const params = paramString && paramString.length > 0 ? qs.parse(paramString.slice(1)) : {};
  const webApiPath = `${UI_WEB_API_PATH}${qs.stringify(
    {
      allowStatisticsCookies: params.allowStatisticsCookies,
      goto: params.goto,
      app: params.app,
      deeplink: params.deeplink,
    },
    { addQueryPrefix: true },
  )}`;

  const fetchWebApiResponse = async () => {
    await API.get(webApiPath).then((response) => {
      const model = response.data;
      if (model.isDeeplink) {
        setDeeplink(model);
      }
      propagateWebApiState(model);
      const handler = client?.handlers.find((handler) => handler.action === model.action);
      if (handler) {
        handler.callback(model);
      }
    });
  };

  if (!client) {
    window.location.replace(webApiPath);
    return null;
  } else {
    fetchWebApiResponse();
  }

  if (deeplink) {
    return (
      <div className={'text-center'}>
        <Button
          onClick={routeStore.navigate}
          iconRight={'#arrow-right'}
          text={translateStore.translate('webapi.deeplinkText')}
          url={deeplink.deeplink}
          external={true}
        />
      </div>
    );
  }

  return <Spinner />;
});

export default WebApi;
